export default function ({ redirect, $auth, route }) {
  if ($auth.loggedIn && $auth.user.role === 3) {
      return redirect({
          path: "/arm",
      })
  }
}
